/**
 * Small byte helpers shared by the wallet crypto layer.
 * Lifted from leokit-sdk + leodex-v2 keystore-creation.ts.
 */

export const bytesToHex = (bytes: Uint8Array): string =>
  Array.from(bytes)
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");

export const hexToBytes = (hex: string): Uint8Array => {
  const clean = hex.startsWith("0x") || hex.startsWith("0X") ? hex.slice(2) : hex;
  if (clean.length % 2 !== 0) throw new Error("Invalid hex string");
  const bytes = new Uint8Array(clean.length / 2);
  for (let i = 0; i < bytes.length; i++) {
    bytes[i] = Number.parseInt(clean.slice(i * 2, i * 2 + 2), 16);
  }
  return bytes;
};

export const concatBytes = (...arrays: Uint8Array[]): Uint8Array => {
  const length = arrays.reduce((total, a) => total + a.length, 0);
  const out = new Uint8Array(length);
  let offset = 0;
  for (const a of arrays) {
    out.set(a, offset);
    offset += a.length;
  }
  return out;
};

export const randomBytes = (n: number): Uint8Array => {
  const out = new Uint8Array(n);
  globalThis.crypto.getRandomValues(out);
  return out;
};

/**
 * @noble libraries return Uint8Array but TS sometimes infers them as `Uint8Array<ArrayBufferLike>`
 * which trips up `crypto.subtle.*` calls that demand `BufferSource`. Cast via copy.
 */
export const toBuffer = (bytes: Uint8Array): Uint8Array<ArrayBuffer> => {
  const out = new Uint8Array(bytes.length);
  out.set(bytes);
  return out as Uint8Array<ArrayBuffer>;
};
